import { defineStore } from 'pinia';
import router from '@/router'; // Import the router to use for redirection
import apiFetch from '@/apiClient'; // Import the apiFetch function

export const useAuthStore = defineStore('auth', {
  state: () => ({
    isAuthenticated: !!localStorage.getItem('token'),
    token: localStorage.getItem('token') || null,
    user: JSON.parse(localStorage.getItem('user')) || null, // Add user to state
    error: null, // Add error state to store
  }),
  getters: {
    isAuth: (state) => state.isAuthenticated,
    getUser: (state) => state.user,
  },
  actions: {
    async login(credentials) {
      this.error = null; // Clear previous errors
      try {
        console.log('Attempting login for', credentials.username);
        const data = await apiFetch('/auth/login', {
          method: "POST",
          body: JSON.stringify({ username: credentials.username, password: credentials.password })
        });
        console.log('Login response data:', data);

        if (data && data.token && (data.role === "admin" || data.role === "superadmin")) {
          localStorage.setItem("token", data.token);
          localStorage.setItem("user", JSON.stringify(data));
          this.token = data.token;
          this.isAuthenticated = true;
          this.user = data;
          
          router.push('/');
          return true;
        } else {
          const errorMessage = data.error || "Accès non autorisé ou identifiants incorrects";
          this.error = errorMessage;
          throw new Error(errorMessage);
        }
      } catch (error) {
        console.error('Login failed:', error);
        this.isAuthenticated = false;
        this.token = null;
        this.user = null;
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        this.error = error.message || "Erreur de connexion au serveur.";
        throw error;
      }
    },
    logout() {
      this.isAuthenticated = false;
      this.token = null;
      this.user = null;
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      router.push('/login');
      console.log('Logged out, redirecting to /login');
    },
    checkAuthStatus() {
      this.isAuthenticated = !!localStorage.getItem('token');
      this.token = localStorage.getItem('token');
      const user = JSON.parse(localStorage.getItem('user'));
      if (user && typeof user.modules === 'string') {
        user.modules = JSON.parse(user.modules); // Parse modules if it's a string
      }
      this.user = user;
      console.log('Auth status checked:', {
        isAuthenticated: this.isAuthenticated,
        token: this.token,
        user: this.user,
      });
    },
  },
});

